// extracted by mini-css-extract-plugin
module.exports = {"header":"Statefull_header__2tkgZ"};